import { limitWordsAndSpaces } from './limitWordsAndSpaces';

export function createOnPasteAtCaret(setValue, currentText, maxWords) {
  return (event) => {
    event.preventDefault();
    const pastedData = event.clipboardData.getData('text');

    const current = currentText || '';
    const start = event.target.selectionStart ?? current.length;
    const end = event.target.selectionEnd ?? start;
    const before = current.slice(0, start);
    const after = current.slice(end);
    const combined = before + pastedData + after;

    const value = limitWordsAndSpaces(combined, maxWords);
    setValue(value);
    requestAnimationFrame(() => {
      const insertedLength =
        value.length - (before.length + after.length);
      const cursorPos = start + Math.max(0, insertedLength);
      event.target.setSelectionRange(cursorPos, cursorPos);
    });
  };
}

export default createOnPasteAtCaret;